import React, { useEffect } from "react";
import { CommonHeader } from "../../components/commons";
import { ClientDashboardCard } from "../../components/ClientDashboard";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";

type AppProps = {
  history: any;
  sideMenus: any;
};

const AdminReports = ({ history, sideMenus }: AppProps) => {
  const [isAdminReportUrlPresent, setIsAdminReportUrlPresent] = useMenuCheck();
  let adminReports: any =
    sideMenus &&
    sideMenus?.length > 0 &&
    sideMenus?.filter((menu: any) => menu?.menu_name === "Admin Reports");
  useEffect(() => {
    setIsAdminReportUrlPresent("/admin-reports", "url");
  }, []);

  useEffect(() => {
    if (isAdminReportUrlPresent === false) {
      history.push("/access-denied");
    }
  }, [isAdminReportUrlPresent]);
  const renderModules = () => {
    let finalList = adminReports[0]?.sub_menu?.map((list: any) => {
      return (
        <div className={`col-md-4 mb-4 ${list.extraClasses}`}>
          <ClientDashboardCard
            isNew={list.is_new}
            key={list.menu_name}
            name={list.menu_name}
            description={list.description}
            icon={<i className={list.icon}></i>}
            action={() => handleRedirection(list.action)}
            comingSoon={list.comingSoon}
          />
        </div>
      );
    });

    return finalList;
  };

  const handleRedirection = (moduleName: string | undefined) => {
    switch (moduleName) {
      case "redirectToJobProgress":
        return handleRedirectToJobProgress();
      case "redirectToAllOpenItems":
        return handleRedirectToAllOpenItems();
      case "redirectToFileFolderCount":
        return handleRedirectToFileFolderCount();
      case "redirectToInvoicingReport":
        return handleRedirectToInvoicingReport();
      case "redirectToAssignedUsersOfClient":
        return handleRedirectToAssignedUserOfClient();
      case "redirectToUserLoginSessionReport":
        return handleRedirectToUserLoginSessionReport();
      case "redirectToAllClientSop":
        return handleRedirectToSops();
      case "redirectToAllEWayBills":
        return handleRedirectToAllEWayBills();
      case "redirectToAllEInvoices":
        return handleRedirectToAllEInvoice();
      case "redirectToAllClientLockReport":
        return handleRedirectToAllClientLockReport();
      case "redirectToExternalUserEmailerTemplateReport":
        return handleRedirectToExternalEmailerReport();
      case "redirectToReportAllUserApprovedEntryReport":
        return handleRedirectToAllUserApprovedEntryCountReport();
      case "redirectToReportBulkUploadReport":
        return handleRedirectToAllBulkUploadReport();
      default:
        return null;
    }
  };

  const handleRedirectToJobProgress = () => {
    history.push(`admin-reports/job-progress`);
  };

  const handleRedirectToAllOpenItems = () => {
    history.push(`admin-reports/all-open-items`);
  };

  const handleRedirectToFileFolderCount = () => {
    history.push(`admin-reports/file-folder-count`);
  };
  const handleRedirectToInvoicingReport = () => {
    history.push(`admin-reports/invoicing-report`);
  };
  const handleRedirectToAssignedUserOfClient = () => {
    history.push(`admin-reports/assign-users`);
  };
  const handleRedirectToSops = () => {
    history.push(`admin-reports/sops`);
  };

  const handleRedirectToAllEWayBills = () => {
    history.push(`admin-reports/all-eway-bills`);
  };

  const handleRedirectToAllEInvoice = () => {
    history.push(`admin-reports/all-e-invoices`);
  };
  const handleRedirectToUserLoginSessionReport = () => {
    history.push({
      pathname: `admin-reports/user-login-session-reports`,
      state: { sideMenus },
    });
  };
  const handleRedirectToAllClientLockReport = () => {
    history.push(`admin-reports/all-client-lock-date`);
  };

  const handleRedirectToExternalEmailerReport = () => {
    history.push(`admin-reports/emailer-template`);
  };
  const handleRedirectToAllUserApprovedEntryCountReport = () => {
    history.push(`admin-reports/all-user-approved-entry`);
  };
  const handleRedirectToAllBulkUploadReport = () => {
    history.push(`admin-reports/all-bulk-upload-report`);
  };

  return (
    <>
      <CommonHeader title="Admin Reports" />
      <div className="row mt-3">{renderModules()}</div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  sideMenus: state.auth.sideMenus,
});

export default connect(mapStateToProps)(AdminReports);
